import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Restringe el acceso a pantallas de administración del tenant a usuarios con
 * rol "Admin" o superior ("Super Admin"). Si no está autenticado → /signin; si
 * está autenticado pero no es Admin/Super Admin → ruta por defecto (contactos).
 */
export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/signin']);
    return false;
  }

  const role = authService.getCurrentUser()?.roleName;
  if (role === 'Admin' || role === 'Super Admin') {
    return true;
  }

  router.navigate(['/contactos']);
  return false;
};
